import script from "./MobileNavigationBackButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./MobileNavigationBackButton.vue?vue&type=script&setup=true&lang=ts"

import "./MobileNavigationBackButton.vue?vue&type=style&index=0&id=03e049a4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03e049a4"]])

export default __exports__